/**
 * BacktestMissionControl.tsx
 *
 * Main two-panel "Mission Control" layout for backtest execution.
 * Left panel: Fixed "Pulse" with clock, progress, and stats.
 * Right panel: Full-height terminal log.
 */

import React from 'react';
import { ProgressStep, LiveStats } from '../../types/backtest';
import MissionControlPulse from './MissionControlPulse';
import BacktestTerminal from './BacktestTerminal';

interface BacktestMissionControlProps {
  steps: ProgressStep[];
  currentMessage: string;
  symbol: string;
  logs: string[];
  isRunning: boolean;
  liveStats: LiveStats;
}

const BacktestMissionControl: React.FC<BacktestMissionControlProps> = ({
  steps,
  currentMessage,
  symbol,
  logs,
  isRunning,
  liveStats
}) => {
  return (
    <div>
      {/* Compact Header */}
      <div className="bt-head">
        <div>
          <h2 className="bt-title">
            Backtesting <span className="n">{symbol}</span>
          </h2>
          <p className="bt-sub">Simulating covered call strategies...</p>
        </div>
      </div>

      {/* Two-Panel Layout - Extended Height */}
      <div className="bt-mc">
        {/* Left Panel: The Pulse */}
        <MissionControlPulse
          steps={steps}
          currentMessage={currentMessage}
          liveStats={liveStats}
        />

        {/* Right Panel: Terminal */}
        <div className="bt-mc-term">
          <BacktestTerminal logs={logs} isRunning={isRunning} />
        </div>
      </div>
    </div>
  );
};

export default BacktestMissionControl;
